import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthService from '../../services/authService';
import { Button, Space } from 'antd';
import { getNextFallbackMenuPath, toCanonicalPath } from '../../utils/menuPaths';

const ProtectedMenuPage = ({ menuKey, children }) => {
    const [allowed, setAllowed] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkPermission = async () => {
            try {
                const res = await AuthService.authAxios.get('/auth/menu/check', {
                    params: { key: menuKey },
                });
                setAllowed(res.data.allowed);
            } catch (error) {
                console.error('❌ 메뉴 권한 체크 실패:', error);
                setAllowed(false);
            }
        };

        checkPermission();
    }, [menuKey]);

    // 권한 확인은 백그라운드에서 진행, 확인 중에는 콘텐츠 표시
    if (allowed === false) {
        const nextPath = getNextFallbackMenuPath(toCanonicalPath(location.pathname));
        return (
            <div className="content-page p-4">
                <h3 className="text-danger">🚫 접근 권한이 없습니다.</h3>
                <p>이 메뉴는 사용 권한이 없습니다. 관리자에게 문의하세요.</p>
                <Space className="mt-2" wrap>
                    {nextPath ? (
                        <Button type="primary" onClick={() => navigate(nextPath)}>
                            다른 메뉴로 이동
                        </Button>
                    ) : null}
                    <Button
                        onClick={() => {
                            AuthService.logout({ redirect: false });
                            navigate('/login');
                        }}
                    >
                        로그아웃
                    </Button>
                </Space>
            </div>
        );
    }

    return <>{children}</>;
};

export default ProtectedMenuPage;
